import { ProviderInstanceBaseModel } from './provider-instance-base-model';

export class BaseProviderInstanceModel extends ProviderInstanceBaseModel {
  providerTypeId: string;
}
